import * as React from 'react'
import {NavigationContainerRef} from '@react-navigation/core'

import {DrawerParamList} from 'src/nav/MainStackParamsList'

export const rootNavigationRef = React.createRef<NavigationContainerRef<DrawerParamList>>()

global.rootNavigationRef = rootNavigationRef
